import { FsLvtCamera } from './lvt-camera';

export class FsLvtIconLayerConfig {
  public pickable: boolean = true;
  public getSize = this._getSize.bind(this);
  public getIcon = this._getIcon.bind(this);
  public getPosition = this._getPosition.bind(this);
  public getAngle = this._getAngle.bind(this);

  constructor(
    public id: string,
    public data: FsLvtCamera[],
    public onClick: Function,
    public onHover: Function,
  ) {}

  private _getSize(camera?: FsLvtCamera): number {
    return 28;
  }

  private _getAngle(camera?: FsLvtCamera): number {
    return 0;
  }

  private _getPosition(camera: FsLvtCamera): number[] {
    return camera.coordinates;
  }

  private _getIcon(camera: FsLvtCamera): any {
    return {
      url: '/assets/fusus-icons/PNG/lvt-circle-green.png',
      height: 32,
      width: 32,
      id: camera.id,
      anchorY: 16,
      anchorX: 16,
    };
  }
}
